import {
  btn,
  errorText,
  inputInfo,
  modalBoxContent,
  modalBoxDesc,
  modalBoxPaper,
  modalBoxText,
  warningBox,
} from './DocSign.sx';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  OutlinedInput,
  Typography,
} from '@mui/material';
import WarningIcon from 'app/components/Icons/WarningIcon';
import React from 'react';
import useDocSign from './useDocSign';
import AsanImza from 'app/components/AsanImzaComponent/AsanImza';

const AsanImzaModal = () => {
  const {
    t,
    showModal,
    showAsanModal,
    handleSubmitForm,
    register,
    firstInput,
    secondInput,
    dataLogWithEmail,
    isLoadingLogWithEmail,
    handleOnChangeAsanID,
    handleOnChangeAsanPhone,
  } = useDocSign();

  if (!showAsanModal) {
    return (
      <Dialog
        open={showModal}
        onClose={(event: any) => {
          event.stopPropagation();
        }}
        PaperProps={{
          sx: modalBoxPaper,
        }}
      >
        <DialogTitle sx={modalBoxContent}>
          <Typography sx={modalBoxText}>{t('docSign.signDoc')}</Typography>
          <Typography sx={modalBoxDesc}>{t('docSign.signAsanImza')}</Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <form style={{ position: 'relative', height: '100%' }} onSubmit={handleSubmitForm}>
            <Typography sx={inputInfo}>{t('login.mobileNumber')}</Typography>
            <OutlinedInput
              type={'text'}
              placeholder={'(00) 000 00 00'}
              sx={{
                width: '100%',
                mb: '24px',
                pl: '16px',

                '@media screen and (max-height: 864px)': {
                  mb: '20px',
                },
              }}
              startAdornment={
                <InputAdornment position="start">
                  <Typography sx={{ fontFamily: 'Yelo', fontWeight: 500 }}>+994</Typography>
                </InputAdornment>
              }
              inputProps={{ style: { paddingLeft: '0' }, ...register('asan_imza_phone') }}
              onChange={handleOnChangeAsanPhone}
              value={firstInput}
            />
            <Typography sx={inputInfo}>{t('login.userID')}</Typography>
            <OutlinedInput
              type={'text'}
              placeholder={t('login.enterUserID')}
              sx={{ width: '100%' }}
              inputProps={{ ...register('asan_imza_id') }}
              onChange={handleOnChangeAsanID}
              value={secondInput}
            />

            {dataLogWithEmail?.error && (
              <Box sx={warningBox}>
                <WarningIcon sx={{ mr: '16px' }} />
                <Typography sx={errorText}>{dataLogWithEmail?.error && dataLogWithEmail?.error.id}</Typography>
              </Box>
            )}

            <Button
              type={'submit'}
              disabled={!(firstInput.length > 0 && secondInput.length > 0) || isLoadingLogWithEmail}
              sx={btn}
              variant={'contained'}
            >
              {isLoadingLogWithEmail ? (
                <CircularProgress sx={{ width: '24px !important', height: '24px !important' }} />
              ) : (
                t('login.continue')
              )}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={showModal}
        onClose={(event: any) => {
          event.stopPropagation();
        }}
        PaperProps={{
          sx: { ...modalBoxPaper, height: '533px' },
        }}
      >
        <AsanImza verifyCode={dataLogWithEmail?.verification_code} />
      </Dialog>
    );
  }
};

export default AsanImzaModal;
